import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DDL } from 'src/app/core-module/models/ddl';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxComponent {
  @Input() currentQuestion: CAQuestion;
  @Output() currentQuestionChange = new EventEmitter<CAQuestion>();



  selectOption(option: DDL) {
    if (this.currentQuestion.NASelected) {
      return;
    }
    option.SelectedOption = !option.SelectedOption;
    this.currentQuestion.AnswerIDs = this.currentQuestion.QuestionAnswers.filter((e) => { return e.SelectedOption }).map(e => { return e.ID });
  this.validateAnswered();
  }
  validateAnswered() {
    if (this.currentQuestion.AnswerIDs.length > 0 || this.currentQuestion.NASelected) {
      this.currentQuestion.IsAnswered = true;
    } else {
      this.currentQuestion.IsAnswered = false;
    };
  }
  updateNA() { 
    this.currentQuestion.NASelected = !this.currentQuestion.NASelected;
    this.validateAnswered();
  }
}
